<template>
    <div class="task_main">

        <topView :topU1="topU1" :topU2="topU2" :topU3="topU3" v-if="tabIndex == 0"></topView>
        <topView :topU1="wtopU1" :topU2="wtopU2" :topU3="wtopU3" v-if="tabIndex == 1"></topView>
        <topView :topU1="otopU1" :topU2="otopU2" :topU3="otopU3" v-if="tabIndex == 2"></topView>

        <div class="rank_tab_layout">
            <div class="task_tab_list_layout">
                <div v-for="(item, index) in taskList" class="rank_home_tab" :key="index" @click="checkTab(index)">
                    <div :class="tabIndex == index ? 'home_tab_red_layout' : 'home_tab_txt_layout'">
                        {{ item.title }}
                    </div>

                    <div :class="tabIndex == index ? 'home_tab_check' : 'home_tab_uncheck'"></div>

                </div>
            </div>
        </div>


        <listView :rankUser="userData" :myself="myself" v-if="tabIndex == 0"></listView>
        <listView :rankUser="w_userData" :myself="w_myself" v-if="tabIndex == 1"></listView>
        <listView :rankUser="o_userData" :myself="o_myself" v-if="tabIndex == 2"></listView>



    </div>
</template>

<script>
import listView from "./userlist.vue";
import topView from "./topView.vue";

import {
    baseUrl
} from "../../util/mock.js"

import icon_avatar from '../../assets/icon_pc_user_avcter.png';


export default {
    name: 'rankView',
    components: { listView, topView },

    props: {
        topU3: {},
        topU2: {},
        topU1: {},
        wtopU3: {},
        wtopU2: {},
        wtopU1: {},
        otopU3: {},
        otopU2: {},
        otopU1: {},

        userData: [],
        w_userData: [],
        o_userData: [],
        myself: {},
        w_myself: {},
        o_myself: {}
    },

    emits: ["rankCheckTab"],
    data() {
        return {
            default_avatar: icon_avatar,
            taskList: [
                { title: "Daily", id: 0 },
                { title: "Weekly", id: 0 },
                { title: "Overall", id: 0 },
            ],
            tabIndex: 0,
        }
    },

    watch: {

    },

    methods: {
        checkTab(index) {
            this.tabIndex = index;
            this.$emit("rankCheckTab", index);
            // if (index == 0) {
            //     this.userData = this.topAll;
            // } else if (index == 1) {
            //     this.userData = this.topWeek;
            // } else {
            //     this.userData = this.topDay;
            // }
            // this.setTopUser(this.userData)
        },

        isDecimal(num) {
            return /^\d+\.\d+$/.test(num);
        },
        setFixNumber(num1) {
            if (this.isDecimal(num1)) {
                let m = Math.pow(10, 2); //放大10的2次方倍  100
                let value = (num1 * m) / m;  //(0.1*100 + 0.2*100）/100
                return value.toFixed(1)
            } else {
                return num1;
            }

        },

    },

    mounted() {
        // this.getData();
    },


}

</script>

<style scoped>
.task_main {
    min-height: 380px;
    display: flex;
    margin-top: 12px;
    flex-direction: column;
    width: -webkit-fill-available;
    width: -moz-available;
    /* max-height: 500px; */
    justify-content: center;
    align-items: center;
    border-radius: 24px;
}

@media (max-width:767.98px) {
    .task_main {
        min-height: 380px;
        display: flex;
        margin-top: 12px;
        flex-direction: column;
        width: -webkit-fill-available;
        width: -moz-available;
        /* max-height: 400px; */
        justify-content: center;
        align-items: center;
        border-radius: 24px;
    }
}

.rank_tab_layout {
    border: 1px #000;
    display: flex;
    flex-direction: row;
    background: #fff;
    justify-content: center;
    align-items: center;
    width: -webkit-fill-available;
    width: -moz-available;
    background-color: #fff;
}

.task_tab_list_layout {
    display: flex;
    flex-direction: row;
    background: #fff;
    width: -webkit-fill-available;
    display: flex;
    justify-content: space-between;
}

.home_tab_red_layout {
    border-radius: 8px;
    background: #FFF;
    color: #FFB001;
    text-align: center;
    -webkit-text-stroke-width: 1;
    -webkit-text-stroke-color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    /* 142.857% */
    letter-spacing: 0.14px;
    padding: 6px 18px;
}

.home_tab_txt_layout {
    color: #666;
    text-align: center;
    -webkit-text-stroke-width: 1;
    -webkit-text-stroke-color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    /* 142.857% */
    letter-spacing: 0.14px;
    background: transparent;
    padding: 6px 18px;

}

.rank_header_layout {
    position: relative;
    width: 78.469px;
    height: 73.187px;
    align-items: center;
    justify-content: center;
    display: flex;
}

.icon_rank_1 {
    width: 78.469px;
    height: 73.187px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background-image: url("../../assets/icon_rank_1.png");
    background-size: cover;
    background-repeat: no-repeat;
}

.icon_rank_2 {
    width: 78.469px;
    height: 73.187px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background-image: url("../../assets/icon_rank_2.png");
    background-size: cover;
    background-repeat: no-repeat;
}

.icon_rank_3 {
    width: 78.469px;
    height: 73.187px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background-image: url("../../assets/icon_rank_3.png");
    background-size: cover;
    background-repeat: no-repeat;
}



.icon_rank_logo {
    width: 56px;
    height: 56px;
    border-radius: 100%;
}

.rank_reward_layout {
    border: 0.5px solid rgba(255, 255, 255, 0.00);
    background: linear-gradient(90deg, rgba(255, 195, 88, 0.00) 0%, #FFB636 52.32%, rgba(255, 195, 88, 0.00) 100%);
    color: #FFF;
    text-align: center;
    text-shadow: 0px 1px 2px rgba(156, 99, 0, 0.30);
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    width: 81.693px;
}

.icon_rank_2_name {
    width: 91.368px;
    height: 21.526px;
    flex-shrink: 0;
    color: #B27100;
    text-align: center;
    text-shadow: 0px 1px 3px rgba(156, 99, 0, 0.20);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.408px;
    background-image: url("../../assets/icon_rank_2_name.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin-top: 4px;
}

.icon_rank_1_name {
    width: 104.368px;
    height: 21.526px;
    flex-shrink: 0;
    color: #B27100;
    text-align: center;
    text-shadow: 0px 1px 3px rgba(156, 99, 0, 0.20);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.408px;
    background-image: url("../../assets/icon_rank_1_name.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin-top: 4px;
}

.icon_rank_3_name {
    width: 91.368px;
    height: 21.526px;
    flex-shrink: 0;
    color: #B27100;
    text-align: center;
    text-shadow: 0px 1px 3px rgba(156, 99, 0, 0.20);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.408px;
    background-image: url("../../assets/icon_rank_3_name.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin-top: 4px;
}

.icon_rank_2_layout {
    background: linear-gradient(180deg, #EF9D00 0%, #FFE0A8 100%);
    width: 91.368px;
    height: 50.585px;
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.icon_rank_1_layout {
    background: linear-gradient(180deg, #EF9D00 0%, #FFE0A8 100%);
    width: 104.368px;
    height: 71.585px;
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.icon_rank_reward_logo {
    width: 11px;
    height: 11px;
    background-image: url("../../assets/icon_task_reward_logo.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin-left: 4px;
}


.rank_xp_txt {
    color: #FFF;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
}

.rank_number {
    color: #F8F8F8;
    text-align: center;
    font-size: 24px;
    font-style: italic;
    font-weight: 900;
    line-height: 26px;
}

.rank_reward_row {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    margin-top: 6px;
}

.rank_layout {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.rank_top {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: end;
    width: 290px;
}

@media (max-width:767.98px) {
    .rank_top {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: end;
        width: 290px;
    }
}




.rank_home_tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
}

.home_tab_check {
    width: 48px;
    height: 2px;
    flex-shrink: 0;
    background-color: #FFB001;
}

.home_tab_uncheck {
    width: 48px;
    height: 2px;
    flex-shrink: 0;
    background-color: transparent;
}
</style>